import script from "./FooterSaintluc.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterSaintluc.vue?vue&type=script&setup=true&lang=js"

import "./FooterSaintluc.vue?vue&type=style&index=0&id=73fb1cb8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73fb1cb8"]])

export default __exports__